import { render, staticRenderFns } from "./shopXq.vue?vue&type=template&id=0b4f77d1&scoped=true"
import script from "./shopXq.vue?vue&type=script&lang=js"
export * from "./shopXq.vue?vue&type=script&lang=js"
import style0 from "./shopXq.vue?vue&type=style&index=0&id=0b4f77d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4f77d1",
  null
  
)

export default component.exports